class GalleryVerticalScroll {
	constructor() {
		this.name = 'gallery-vertical-scroll';
		this.components = document.querySelectorAll(`.${this.name}`);
		this.isScrolling = false; 

		if (this.components.length > 0) {
			this.init();
		}
	}

	init() {
		if(window.innerWidth < 961) return;
		this.components.forEach((comp) => {
			const clickableBoxes = comp.querySelectorAll('.clickable-box');
			const galleryBoxes = comp.querySelectorAll('.gallery-box');
			if (clickableBoxes.length > 0 && galleryBoxes.length > 0) {
				this.listenClickBoxes = this.listenClickBoxes.bind(this);
				this.handleScroll = this.handleScroll.bind(this);
				this.listenClickBoxes(clickableBoxes);
				window.addEventListener('scroll', () => this.handleScroll(galleryBoxes, clickableBoxes));
			}
		});
	}

	listenClickBoxes(clickableBoxes) {
		clickableBoxes.forEach((box) => {
			box.addEventListener('click', () => {

				this.isScrolling = true; 
				clickableBoxes.forEach((el) => el.classList.remove('active'));
				box.classList.add('active');

				const targetIndex = box.getAttribute('data-target');
				const targetBox = box.closest('.gallery-vertical-scroll').querySelector(`.gallery-box[data-box="${targetIndex}"]`);
				
				targetBox.scrollIntoView({ behavior: 'smooth', block: 'start' });

				setTimeout(() => {
					this.isScrolling = false;
				}, 500); 
			});
		});
	}

	handleScroll(galleryBoxes, clickableBoxes) {
		if (this.isScrolling) return;

		let activeIndex = null;
		galleryBoxes.forEach((box, index) => {
			const rect = box.getBoundingClientRect();
			const boxCenter = rect.top + rect.height / 2;
			if (boxCenter >= window.innerHeight / 2 && boxCenter <= window.innerHeight) {
				activeIndex = index;
			}
		});
		if (activeIndex !== null) {
			clickableBoxes.forEach((el) => el.classList.remove('active'));
			const activeBox = clickableBoxes[0].closest('.gallery-vertical-scroll').querySelector(`.clickable-box[data-target="${activeIndex}"]`);
			if (activeBox) activeBox.classList.add('active');
		}
	}
}

const galleryVerticalScroll = new GalleryVerticalScroll();
